{
  "name": "copisteria",
  "version": "1.9.13",
  "author": "A2System",
  "homepage": "https://www.a2system.net/",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "bump-version": "npm version patch -m %s",
    "develop": "ng build --output-hashing=all && firebase deploy -c firebase.dev.json -m $npm_package_version --project=copias-a-domicilio-develop",
    "develop-win": "ng build --output-hashing=all && firebase deploy -c firebase.dev.json -m %npm_package_version% --project=copias-a-domicilio-develop",
    "develop-channel": "ng build --output-hashing=all && firebase hosting:channel:deploy app-preview -c firebase.dev.json --project=copias-a-domicilio-develop",
    "prod": "ng build --configuration production && firebase deploy -m $npm_package_version --project=copias-a-domicilio",
    "prod-win": "ng build --configuration production && firebase deploy -m %npm_package_version% --project=copias-a-domicilio",
    "prod-channel": "ng build --configuration production && firebase hosting:channel:deploy app-preview --project=copias-a-domicilio",
    "compodoc": "npx compodoc -p tsconfig.doc.json --includes extras",
    "docs:json": "compodoc -p ./tsconfig.json -e json -d .",
    "deploy-all-win": "npm run develop-win && npm run prod-win"
  },
  "engines": {
    "node": ">=20.19.0"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.2.14",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.2.14",
    "@angular/compiler": "^20.2.14",
    "@angular/core": "^20.2.14",
    "@angular/fire": "20.0.1",
    "@angular/forms": "^20.2.14",
    "@angular/google-maps": "^20.2.14",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.2.14",
    "@angular/platform-browser-dynamic": "^20.2.14",
    "@angular/router": "^20.2.14",
    "@babel/runtime": "^7.23.6",
    "@cloudfactorydk/ng2-tooltip-directive": "^18.0.0",
    "@ionic/angular": "^8.8.1",
    "@ngneat/until-destroy": "^10.0.0",
    "@types/fabric": "^5.3.6",
    "@types/semver": "^7.3.8",
    "angular-google-tag-manager": "1.12.0",
    "angular-iban": "^20.0.0",
    "animate.css": "^4.1.1",
    "crypto-js": "^4.2.0",
    "date-fns": "^2.23.0",
    "fabric": "5.3.0-browser",
    "lodash-es": "^4.17.23",
    "lottie-web": "5.9.2",
    "ngx-cookie-service": "^20.1.1",
    "ngx-file-drop": "^16.0.0",
    "ngx-lottie": "20.0.0",
    "npm": "^10.2.5",
    "rxjs": "7.8.2",
    "semver": "^5.7.1",
    "slugify": "^1.6.0",
    "swiper": "^11.0.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.2.14",
    "@angular/cli": "^20.2.14",
    "@angular/compiler-cli": "^20.2.14",
    "@angular/elements": "^20.2.14",
    "@angular/language-service": "^20.2.14",
    "@ionic/cli": "^7.2.1",
    "@types/jasmine": "^3.6.2",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^20.19.0",
    "@webcomponents/custom-elements": "^1.4.3",
    "autoprefixer": "^10.4.18",
    "firebase-tools": "^14.27.0",
    "jasmine-core": "~4.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "ng-packagr": "^20.3.2",
    "postcss": "^8.4.35",
    "prettier": "^3.8.1",
    "prettier-plugin-tailwindcss": "^0.7.2",
    "tailwindcss": "^3.4.1",
    "typescript": "5.8.3"
  },
  "optionalDependencies": {
    "@rollup/rollup-darwin-arm64": "*",
    "@rollup/rollup-win32-x64-msvc": "*"
  },
  "overrides": {
    "@cloudfactorydk/ng2-tooltip-directive": {
      "@angular/common": "^20.2.14",
      "@angular/core": "^20.2.14"
    }
  },
  "description": "CopyFly"
}
